import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl87ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup
      .object()
      .shape({
        value: yup.string().required("Το πεδίο είναι υποχρεωτικό"),
        label: yup.string().required("Το πεδίο είναι υποχρεωτικό"),
      })
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocAssessmentReport: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    decision_purpose_id: yup.object().shape({
      value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      label: yup.string(),
    }),
  });
};

export default appl87ValidationSchema;
